import { render, staticRenderFns } from "./MockHeader.vue?vue&type=template&id=e0b33f68&"
import script from "./MockHeader.vue?vue&type=script&lang=js&"
export * from "./MockHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports